module.exports = __webpack_public_path__ + "static/anconsult-8519ab82e3cc0df77ebcd64ce94fc392.png";